import Settings from './PermissionsManagement';

export default Settings;
